// https://docs.sentry.io/platforms/javascript/configuration/options/#allow-urls

const OTOVO_URLS = /^(?!.*(santander)).*otovo./;
const VERCEL_PREVIEW_URLS = /.*vercel.*/;

module.exports = [OTOVO_URLS, VERCEL_PREVIEW_URLS];
